import * as React from 'react';
import { autobind } from 'core-decorators';
import { Accordion, Icon } from 'semantic-ui-react';
import isEqual from 'lodash/isEqual';
import { DATA_TEST_ID } from '../data-test-id';
import { IMeta, IUi, IValues } from '../../interfaces/state';
import './tab-content.less';
import AnimateHeight from 'react-animate-height';
import { TRANSITION_DURATION } from '@logicmanager/common';

export class TabContent extends React.Component<ITabContentProps, {}> {
    constructor(props: ITabContentProps) {
        super(props);
    }

    public shouldComponentUpdate(nextProp: ITabContentProps): boolean {
        return !isEqual(nextProp.ui.tabOpened[nextProp.id], this.props.ui.tabOpened[this.props.id])
            || !isEqual(nextProp.meta.users, this.props.meta.users)
            || !isEqual(nextProp.meta.countries, this.props.meta.countries)
            || !isEqual(nextProp.meta.states, this.props.meta.states);
    }

    @autobind
    public handleClick(e: React.SyntheticEvent): void {
        this.props.setTabStatus(this.props.id, !this.props.ui.tabOpened[this.props.id]);
    }

    public render(): JSX.Element {
        return (
            <div data-component="tab-content" data-test-id={DATA_TEST_ID.TAB_CONTENT}>
                <Accordion.Title
                    active={this.props.ui.tabOpened[this.props.id]}
                    onClick={this.handleClick}
                >
                    <Icon name="dropdown" />
                    {this.props.title}
                </Accordion.Title>
                <AnimateHeight duration={TRANSITION_DURATION} height={this.props.ui.tabOpened[this.props.id] ? 'auto' : 0}>
                  <Accordion.Content active={this.props.ui.tabOpened[this.props.id]}>
                      {this.props.content}
                  </Accordion.Content>
                </AnimateHeight>
            </div>
        );
    }
}

export interface ITabContentProps {
    readonly id?: string;
    readonly title?: string;
    readonly opened?: boolean;
    readonly content?: JSX.Element;
    readonly ui: IUi;
    readonly meta: IMeta;
    readonly values: IValues;
    setTabStatus(tabId: string, opened: boolean): void;
}
